<template>
  <div class="opt-in__wrapper">
    <label
      v-if="subscribeEmail"
      for="emailOptInCheckbox">
      <input
        id="emailOptInCheckbox"
        v-model="emailChecked"
        type="checkbox" 
      >
      {{ subscribeEmailLabel }}
    </label>
    <label
      v-if="subscribeSms"
      for="textOptInCheckbox">
      <input 
        id="textOptInCheckbox"
        v-model="textChecked"
        type="checkbox" 
      >
      {{ subscribeSmsLabel }}
    </label>
    <div
      v-if="privacyPolicyDisclaimer"
      class="p2a-privacy-policy-disclaimer" 
      v-html="privacyPolicyDisclaimer"/>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "OptInForm",
  computed: {
    ...mapState("campaign", {
      subscribeEmail: state => state.subscribeEmail,
      subscribeEmailLabel: state => state.subscribeEmailLabel,
      subscribeSms: state => state.subscribeSms,
      subscribeSmsLabel: state => state.subscribeSmsLabel
    }),
    ...mapState("forms", {
      formValues: state => state.formValues
    }),
    ...mapState("wdyk", {
      privacyPolicyDisclaimer: state => state.privacyPolicyDisclaimer
    }),
    emailChecked: {
      set(value) {
        this.setFormValue({ fieldName: "subscribeEmail", value });
      },
      get() {
        return this.formValues.subscribeEmail;
      }
    },
    textChecked: {
      set(value) {
        this.setFormValue({ fieldName: "subscribeSms", value });
      },
      get() {
        return this.formValues.subscribeSms;
      }
    }
  },
  methods: {
    ...mapActions({
      setFormValue: "forms/formValues"
    })
  }
};
</script>
